export default "__VITE_ASSET__aa539b09__"